import { SEND_SUPPORT_MESSAGE, FETCH_SUPPORT_MESSAGES } from './constants';
import { CONNECT_SOCKET } from '../socket/constants';
import { phrApi, phrApiV2 } from '../../api/api';

export function sendSupportMessage(messageObj) {
  return {
    type: SEND_SUPPORT_MESSAGE,
    payload: messageObj,
    socket: {
      namespace: 'support',
      channel: 'message',
    },
  };
}

export function fetchSupportMessages(providerId) {
  const messages = phrApi('get', `message/support/user/${providerId}`, null);
  return dispatch => {
    messages
      .then(response => dispatch({ type: FETCH_SUPPORT_MESSAGES, payload: response }))
      .catch(error => {
        throw new Error('Fetch Support Messages Not Working');
      });
  };
}
export function connectSocket() {
  return { type: CONNECT_SOCKET };
}
